/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Application_Overview_Status_ApprovedInputs */

const en_landing_application_overview_status_approved = /** @type {(inputs: Landing_Application_Overview_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approved by you`)
};

const de_landing_application_overview_status_approved = /** @type {(inputs: Landing_Application_Overview_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von dir freigegeben`)
};

const fr_landing_application_overview_status_approved = /** @type {(inputs: Landing_Application_Overview_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuvée par vous`)
};

const es_landing_application_overview_status_approved = /** @type {(inputs: Landing_Application_Overview_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobada por ti`)
};

const it_landing_application_overview_status_approved = /** @type {(inputs: Landing_Application_Overview_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvata da te`)
};

const nl_landing_application_overview_status_approved = /** @type {(inputs: Landing_Application_Overview_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Door jou goedgekeurd`)
};

const pl_landing_application_overview_status_approved = /** @type {(inputs: Landing_Application_Overview_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatwierdzona przez Ciebie`)
};

const fi_landing_application_overview_status_approved = /** @type {(inputs: Landing_Application_Overview_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyväksymäsi`)
};

const da_landing_application_overview_status_approved = /** @type {(inputs: Landing_Application_Overview_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godkendt af dig`)
};

const sv_landing_application_overview_status_approved = /** @type {(inputs: Landing_Application_Overview_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godkänd av dig`)
};

/**
* | output |
* | --- |
* | "Approved by you" |
*
* @param {Landing_Application_Overview_Status_ApprovedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_application_overview_status_approved = /** @type {((inputs?: Landing_Application_Overview_Status_ApprovedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Application_Overview_Status_ApprovedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_application_overview_status_approved(inputs)
	if (locale === "fr") return fr_landing_application_overview_status_approved(inputs)
	if (locale === "es") return es_landing_application_overview_status_approved(inputs)
	if (locale === "it") return it_landing_application_overview_status_approved(inputs)
	if (locale === "nl") return nl_landing_application_overview_status_approved(inputs)
	if (locale === "pl") return pl_landing_application_overview_status_approved(inputs)
	if (locale === "fi") return fi_landing_application_overview_status_approved(inputs)
	if (locale === "da") return da_landing_application_overview_status_approved(inputs)
	if (locale === "sv") return sv_landing_application_overview_status_approved(inputs)
	return en_landing_application_overview_status_approved(inputs)
});